import { Dispatch, SetStateAction, useState } from 'react';

import { CachedOutlined, ExitToApp, MoreVert, StoreOutlined, SupportAgentOutlined } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { BottomSheet } from 'components/docked';
import { MenuSystemButton } from 'components/header/menu-system/MenuSystemButton';
import { MenuSystemSessionAlert } from 'components/header/menu-system/MenuSystemSessionAlert';
import { MenuSystemShortcuts } from 'components/header/menu-system/mobile/MenuSystemShortcuts';
import { useApplicationContext } from 'context/ApplicationContext';
import { useClientContext } from 'context/ClientContext';
import { useDeskManager } from 'hooks/useDeskManager';

export function MenuSystemMobile({
    setOpenChangeStoreModal,
    setOpenLogoutConfirm,
}: {
    setOpenChangeStoreModal: Dispatch<SetStateAction<boolean>>;
    setOpenLogoutConfirm: Dispatch<SetStateAction<boolean>>;
}) {
    const { user, store } = useApplicationContext();
    const [open, setOpen] = useState(false);
    const { fgAlteraEmpresa } = useClientContext();
    const { openDeskManager, isFetching } = useDeskManager();
    const { fgExibeHelpDesk } = useClientContext();

    /**
     * Fecha o menu e abre o modal de mudança de empresa
     */
    const handleChangeStore = () => {
        setOpen(false);

        setTimeout(() => setOpenChangeStoreModal(true), 100);
    };

    /**
     * Fecha o menu e abre o modal de logout
     */
    const handleLogout = () => {
        setOpen(false);

        setTimeout(() => setOpenLogoutConfirm(true), 100);
    };

    return (
        <>
            <MenuSystemButton onClick={() => setOpen((prev) => !prev)} />

            <BottomSheet
                open={open}
                minHeight={0}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                title={
                    <>
                        <MoreVert />
                        Sistema
                    </>
                }
            >
                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'stretch', minWidth: 0 }}>
                    <Box sx={{ width: 3, borderRadius: 2, backgroundColor: 'primary.main' }} />

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0, flex: 1 }}>
                        <Typography
                            sx={{
                                color: 'text.primary',
                                fontSize: 18,
                                fontWeight: 600,
                                lineHeight: 1.15,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                            }}
                        >
                            {user.dsUsuario}
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
                            <StoreOutlined sx={{ fontSize: 16, color: 'primary.main', flexShrink: 0 }} />

                            <Typography
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    lineHeight: 1.2,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                }}
                            >
                                {store.dsNomeFantasia}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <MenuSystemSessionAlert />

                <MenuSystemShortcuts />

                {fgAlteraEmpresa && (
                    <Button startIcon={<CachedOutlined />} onClick={handleChangeStore} variant="contained">
                        Trocar Empresa
                    </Button>
                )}

                <Box sx={{ display: 'flex', gap: 2 }}>
                    {fgExibeHelpDesk && (
                        <Button startIcon={<SupportAgentOutlined />} onClick={openDeskManager} loading={isFetching} variant="outlined" fullWidth>
                            Suporte
                        </Button>
                    )}

                    <Button startIcon={<ExitToApp />} onClick={handleLogout} variant="outlined" fullWidth>
                        Sair
                    </Button>
                </Box>
            </BottomSheet>
        </>
    );
}
